export default __webpack_public_path__ + "static/media/IMG_5005-min.ca93eeb6.JPG";